<div class="p-2 w-100">
  
    <!-- Header minimalista -->
    <div class="uncp-header text-white p-4 py-3 mb-4">
        <div class="d-flex justify-content-between align-items-center">
            <div>
                <button type="button" routerLink="../" class="btn btn-danger btn-sm mb-2" style="width: 120px;">
                    <i class="fas fa-arrow-left me-2"></i>
                    Volver
                </button>
                <h3 class="mb-1 fw-light">
                    <i class="fas fa-users me-2"></i>
                    {{ tiporesolucion.Name }} - Gestión de Resoluciones y Actas
                </h3>
            </div>
            <div class="d-flex gap-2">
                <button class="btn btn-outline-light" data-bs-toggle="modal" data-bs-target="#modalImportar">
                    <i class="fas fa-upload me-1"></i>
                    Importar PDFs
                </button>
                <button class="btn btn-light uncp-btn" data-bs-toggle="modal" data-bs-target="#modalAdd" (click)="resetForm()">
                    <i class="fas fa-plus me-1"></i>
                    Nuevo
                </button>
            </div>
        </div>
    </div>

    <!-- Estadísticas rápidas -->
    <div class="card border-0 shadow-sm mb-4">
        <div class="card-body py-3">
            <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                    <i class="fas fa-chart-bar text-info fs-4 me-3"></i>
                    <div>
                        <h6 class="mb-0 fw-bold">Total de resoluciones/actas</h6>
                        <span class="text-muted">Registrados en el sistema</span>
                    </div>
                </div>
                <span class="badge bg-info fs-5 px-3 py-2">{{pages[0]?.rows || 0}}</span>
            </div>
        </div>
    </div>

    <!-- Controles de búsqueda y filtros -->
    <div class="row mx-0 mb-3 align-items-center">
        <div class="col-md-6 px-1">
            <div class="input-group">
                <span class="input-group-text"><i class="fas fa-search"></i></span>
                <input type="text" class="form-control" placeholder="Buscar resoluciones..." 
                    [(ngModel)]="searchTerm" (input)="paginar();">
            </div>
        </div>
        <div class="col-md-6 px-1 text-md-end mt-2 mt-md-0">
            <div class="d-flex align-items-center justify-content-md-end">
                <span class="me-2 small text-muted">Mostrar:</span>
                <select class="form-select form-select-sm w-auto" [(ngModel)]="pageSize" (change)="paginar();">
                    <option value="20">20</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                </select>
            </div>
        </div>
    </div>

    <!-- Tabla -->
    <div class="card uncp-card">
        <div class="table-responsive">
            <table class="table table-hover uncp-table mb-0">
                <thead>
                    <tr>
                        <th style="min-width: 15px;">#</th>
                        <th>Resoluciones / Actas</th>
                        <th *ngIf="tiporesolucion.OrderByFaculty">Facultad</th>
                        <th>Fecha</th>
                        <th class="text-center">Adjunto</th>
                        <th class="text-center" style="width: 120px;">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- Loading -->
                    <tr *ngIf="!ready">
                        <td colspan="8" class="text-center py-4">
                        <div class="spinner-border text-uncp" role="status"></div>
                        <div class="mt-2">Cargando...</div>
                        </td>
                    </tr>
                    <!-- Sin resultados -->
                    <tr *ngIf="ready && usuarios.length === 0">
                        <td colspan="8" class="text-center py-4 text-muted">
                            No se encontraron resultados
                        </td>
                    </tr>
                    <!-- Datos -->
                    <tr *ngFor="let p of usuarios; let i = index">
                        <td class="text-muted small">{{(pageActive-1)*pageSize+i+1}}</td>
                        <td class="d-none d-md-table-cell">{{p.Name}}</td>
                        <td class="d-none d-md-table-cell" *ngIf="tiporesolucion.OrderByFaculty">
                            {{p.FacultyName || '---'}}
                        </td>
                        <td class="">{{p.Date | date:'dd/MM/yyyy'}}</td>
                        <td class="text-center">
                            <a *ngIf="p.IsLink" [href]="p.Url" target="_blank" class="btn btn-sm btn-outline-secondary" title="Ver Enlace">
                                <i class="fas fa-link"></i>
                            </a>
                            <a *ngIf="!p.IsLink" [href]="'https://erptransparencia.uncp.edu.pe/documentos/' + p.Url" target="_blank" class="btn btn-sm btn-outline-secondary" title="Ver Adjunto">
                                <i class="fas fa-file-alt"></i>
                            </a>
                        </td>
                        <td class="text-center">
                            <div class="btn-group btn-group-sm">
                                <button class="btn btn-outline-primary" (click)="edit(p)" title="Editar" data-bs-toggle="modal" data-bs-target="#modalAdd">
                                    <i class="fas fa-edit"></i>
                                </button>
                                <button class="btn btn-outline-danger" (click)="eliminar(p)" title="Eliminar" data-bs-toggle="modal" data-bs-target="#modalEliminar">
                                    <i class="fas fa-trash"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <!-- Paginación -->
    <div class="d-flex justify-content-between align-items-center mt-3" *ngIf="pages && pages.length > 0">
        <div class="text-muted small">
            Mostrando {{(pageActive-1)*pageSize + 1}} de {{pages[0]?.rows || 0}}
        </div>
        <nav>
            <ul class="pagination pagination-sm mb-0">
                <li class="page-item" [ngClass]="{'disabled': pageActive === 1}">
                <a class="page-link" (click)="getData(1)" style="cursor:pointer;">
                    <i class="fas fa-angle-double-left"></i>
                </a>
                </li>
                <li class="page-item" [ngClass]="{'disabled': pageActive === 1}">
                <a class="page-link" (click)="getData(pageActive - 1)" style="cursor:pointer;">
                    <i class="fas fa-chevron-left"></i>
                </a>
                </li>
                <li *ngFor="let page of pages" class="page-item" 
                    [ngClass]="{
                    'active': pageActive == page.pagina, 
                    'd-none': (page.pagina > (pageActive + 2)) || (page.pagina < (pageActive - 2))
                    }">
                <a class="page-link" (click)="getData(page.pagina)" style="cursor:pointer;">
                    {{page.pagina}}
                </a>
                </li>
                <li class="page-item" [ngClass]="{'disabled': pageActive === pages.length}">
                <a class="page-link" (click)="getData(pageActive + 1)" style="cursor:pointer;">
                    <i class="fas fa-chevron-right"></i>
                </a>
                </li>
                <li class="page-item" [ngClass]="{'disabled': pageActive === pages.length}">
                <a class="page-link" (click)="getData(pages.length)" style="cursor:pointer;">
                    <i class="fas fa-angle-double-right"></i>
                </a>
                </li>
            </ul>
        </nav>
    </div>

</div>






<!-- Modal Crear/Editar -->
<div class="modal fade" id="modalAdd" tabindex="-1" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header bg-uncp text-white">
                <h5 class="modal-title">
                <i class="fas fa-user-edit me-2"></i>
                {{ !usuario.Id ? 'Nueva Resolución' : 'Editar Resolución' }}
                </h5>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" (click)="resetForm()"></button>
            </div>
            
            <form #proyectoForm="ngForm" (ngSubmit)="submit()" novalidate>
                <div class="row modal-body p-4">
                    
                    <!-- Nombre -->
                    <div class="col-6 mb-3">
                        <label class="form-label">Nombre <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" placeholder="Nombre"
                            [(ngModel)]="usuario.Name" name="Name" required>
                    </div>
                    
                    <!-- Fecha -->
                    <div class="col-6 mb-3">
                        <label class="form-label">Fecha <span class="text-danger">*</span></label>
                        <input type="date" class="form-control" placeholder="Fecha"
                            [(ngModel)]="usuario.Date" name="Date" required>
                    </div>

                    <!-- Facultad -->
                    <div class="col-12 mb-3" *ngIf="tiporesolucion.OrderByFaculty">
                        <label class="form-label">Facultad <span class="text-danger">*</span></label>
                        <select class="form-select" [(ngModel)]="usuario.FacultyId" name="FacultyId" required>
                            <option value="null" selected disabled>Seleccionar Facultad</option>
                            <option *ngFor="let facultad of facultades" [value]="facultad.Id">{{facultad.Name}}</option>
                        </select>
                    </div>

                    <!-- Contenido -->
                    <div class="col-12 mb-3">
                        <label class="form-label">Contenido</label>
                        <textarea class="form-control lh-1" placeholder="" rows="5" 
                            [(ngModel)]="usuario.Content" name="Content" required style="white-space: pre-wrap;"></textarea>
                    </div>

                    <!-- Adjuntar archivo o enlace -->
                    <div class="mb-3">
                        <label class="form-label">Adjuntar Archivo o Enlace <span class="text-danger">*</span></label>
                        <br>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="isLinkOptions" id="isLink1"
                                (click)="onIsLinkChange(0)" required [checked]="usuario.IsLink == 0">
                            <label class="form-check-label" for="isLink1">Archivo</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="isLinkOptions" id="isLink2"
                                (click)="onIsLinkChange(1)" required [checked]="usuario.IsLink == 1">
                            <label class="form-check-label" for="isLink2">Enlace</label>
                        </div>
                    </div>
                    <div class="mb-3" *ngIf="usuario.IsLink == 0">
                        <label class="form-label">Archivo (PDF) <span class="text-danger">*</span></label>
                            <span class="ms-3" *ngIf="usuario.Id && usuario.IsLink==0 && usuario.Url">
                                <a [href]="'https://erptransparencia.uncp.edu.pe/documentos/' + usuario.Url" target="_blank" class="btn btn-sm btn-outline-secondary">
                                    <i class="fas fa-file-alt me-1"></i>
                                    Ver archivo actual
                                </a>
                            </span>
                        <input type="file" id="fileInput" class="form-control" (change)="onFileSelected($event)" [required]="!usuario.Id" required accept=".pdf">
                        <small class="form-text text-muted">Tamaño máximo: 25MB. Solo PDF.</small>
                    </div>
                    <div class="mb-3" *ngIf="usuario.IsLink == 1">
                        <label class="form-label">Enlace (URL) <span class="text-danger">*</span></label>
                        <input type="url" class="form-control" placeholder="https://example.com"
                            [(ngModel)]="usuario.Url" name="Url" required>
                        <small class="form-text text-muted">Asegúrate de ingresar una URL válida.</small>
                    </div>
                    
                    
                    <!-- Info adicional -->
                    <div *ngIf="usuario.Id" class="alert alert-light">
                        <small class="text-muted">
                        <i class="fas fa-info-circle me-1"></i>
                        ID: {{usuario.Id}}
                        </small>
                    </div>
                </div>
                
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="resetForm()" [disabled]="!btn">
                        Cancelar
                    </button>
                    <button type="submit" class="btn btn-primary" [disabled]="!btn || !proyectoForm.form.valid">
                        <span *ngIf="!btn" class="spinner-border spinner-border-sm me-1"></span>
                        {{ !usuario.Id ? 'Crear' : 'Actualizar' }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Modal Eliminar -->
<div class="modal fade" id="modalEliminar" data-bs-backdrop="static" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-sm">
        <div class="modal-content">
            <div class="modal-header bg-danger text-white">
                <h6 class="modal-title">
                <i class="fas fa-trash me-2"></i>
                Confirmar Eliminación
                </h6>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" (click)="resetForm();"></button>
            </div>
            <div class="modal-body">
                <div class="text-center">
                <i class="fas fa-exclamation-triangle text-warning fa-2x mb-3"></i>
                <p>¿Eliminar el usuario <strong>{{usuario.Name}}</strong>?</p>
                <small class="text-muted">Esta acción no se puede deshacer.</small>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="resetForm();" [disabled]="!btn">
                Cancelar
                </button>
                <button *ngIf="btn" type="button" class="btn btn-danger" (click)="eliminar({})">
                Eliminar
                </button>
                <button *ngIf="!btn" type="button" class="btn btn-danger" disabled>
                <span class="spinner-border spinner-border-sm me-1"></span>
                Eliminando...
                </button>
            </div>
        </div>
    </div>
</div>


<!-- Modal Importar PDFs -->
<div class="modal fade" id="modalImportar" data-bs-backdrop="static" tabindex="-1">
    <div class="modal-dialog modal-xl modal-dialog-centered">
        <form class="modal-content" (submit)="guardarArchivos();">
            <!-- Header del Modal -->
            <div class="modal-header bg-uncp text-white">
                <h5 class="modal-title">
                    <i class="fas fa-upload me-2"></i>
                    Importar Resoluciones desde PDFs
                </h5>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
            </div>
            
            <!-- Cuerpo del Modal -->
            <div class="modal-body p-3">
                
                <!-- Instrucciones -->
                <div class="alert alert-info border-0 mb-2">
                    <div class="d-flex">
                        <i class="fas fa-info-circle me-3 mt-1"></i>
                        <div>
                            <h6 class="mb-1">Instrucciones para importar</h6>
                            <p class="mb-0">
                                Sube múltiples archivos PDF arrastrándolos aquí o haciendo clic para seleccionarlos, luego presiona procesar. 
                            </p>
                        </div>
                    </div>
                </div>

                <!-- Zona de Drop y Upload -->
                <div class="row">
                    <div class="col-12">
                        <div class="upload-zone border-2 border-dashed rounded-3 p-4 text-center mb-4" 
                             style="border-color: #dee2e6; background-color: #f8f9fa; min-height: 200px; position: relative; cursor: pointer;"
                             onmouseover="this.style.borderColor='#0d6efd'; this.style.backgroundColor='#e7f1ff';"
                             onmouseout="this.style.borderColor='#dee2e6'; this.style.backgroundColor='#f8f9fa';">
                            
                            <!-- Icono y texto principal -->
                            <div class="upload-content" style="pointer-events: none;">
                                <i class="fas fa-cloud-upload-alt fa-3x text-primary mb-3"></i>
                                <h5 class="text-primary mb-2">Arrastra y suelta tus archivos PDF aquí</h5>
                                <p class="text-muted mb-3">o haz clic para seleccionar archivos</p>
                                <button type="button" class="btn btn-outline-primary">
                                    <i class="fas fa-folder-open me-2"></i>
                                    Seleccionar archivos
                                </button>
                                <p class="small text-muted mt-3 mb-0">
                                    Formatos admitidos: PDF | Tamaño máximo: 10MB por archivo
                                </p>
                            </div>

                            <!-- Input file oculto -->
                            <input type="file" 
                                   id="pdfFiles" 
                                   multiple 
                                   accept=".pdf,application/pdf"
                                   style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; opacity: 0; cursor: pointer;"
                                   [disabled]="!btn"
                                   (change)="onFilesSelected($event)">
                        </div>
                    </div>
                </div>

                <!-- Lista de archivos seleccionados -->
                <div class="selected-files-section">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                        <h6 class="mb-0 fw-bold">
                            Archivos seleccionados (<span class="text-primary">{{resolucionesCargadas.length}}</span>)
                        </h6>
                        <button type="button" class="btn btn-sm btn-outline-danger" (click)="clearFilesInput();" [disabled]="!btn">
                            <i class="fas fa-trash me-1"></i>
                            Limpiar todo
                        </button>
                    </div>

                    <!-- Tabla de archivos -->
                    <div class="table-responsive" style="">
                        <table class="table table-sm table-hover">
                            <thead class="table-light sticky-top">
                                <tr>
                                    <th class="text-center" style="min-width: 10px;">#</th>
                                    <th>Archivo</th>
                                    <th class="text-center" style="width: 100px;">Tamaño</th>
                                    <th class="text-center" style="width: 120px;">Estado</th>
                                    <th class="text-center" style="width: 80px;">Acción</th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngIf="resolucionesCargadas.length === 0">
                                    <tr>
                                        <td colspan="5" class="text-center py-4 text-muted">
                                            No hay archivos seleccionados
                                        </td>
                                    </tr>
                                </ng-container>
                                <ng-container *ngIf="resolucionesCargadas.length > 0">
                                    <tr *ngFor="let data of resolucionesCargadas; let i = index">
                                        <td class="align-middle text-center">{{ i + 1 }}</td>
                                        <td class="align-middle">
                                            <p class="lh-sm m-0"><i class="fas fa-file-pdf text-danger"></i> {{ data.File?.name || 'Sin nombre'}}</p>
                                        </td>
                                        <td class="align-middle text-center">
                                            <span class="badge bg-light text-dark">{{ formatFileSize(data.File?.size) || 'Archivo dañado' }}</span>
                                        </td>
                                        <td class="align-middle text-center">
                                            <span class="badge bg-secondary" *ngIf="data.LoadEstate === 0">
                                                <i class="fas fa-clock me-1"></i>Pendiente
                                            </span>
                                            <span class="badge bg-warning" *ngIf="data.LoadEstate === 1">
                                                <i class="fas fa-spinner fa-spin me-1"></i>Subiendo
                                            </span>
                                            <span class="badge bg-primary" *ngIf="data.LoadEstate === 2">
                                                <i class="fas fa-spinner fa-spin me-1"></i>Procesando
                                            </span>
                                            <span class="badge bg-success" *ngIf="data.LoadEstate === 4">
                                                <i class="fas fa-check-circle me-1"></i>Procesado
                                            </span>
                                            <span class="badge bg-danger" *ngIf="data.LoadEstate === 3">
                                                <i class="fas fa-exclamation-triangle me-1"></i>Error
                                            </span>
                                        </td>
                                        <td class="align-middle text-center">
                                            <button class="btn btn-sm btn-outline-danger" title="Eliminar" (click)="clearFileInput(i);" [disabled]="!btn">
                                                <i class="fas fa-times"></i>
                                            </button>
                                        </td>
                                    </tr>
                                </ng-container>
                            </tbody>
                        </table>
                    </div>

                    <!-- Botón Procesar -->
                    <div class="text-center mt-2">
                        <button type="button" class="btn btn-primary px-5" (click)="subirArchivos();" [disabled]="resolucionesCargadas.length === 0 || !btn">
                            <ng-container *ngIf="!btn">
                                <span class="spinner-border spinner-border-sm me-1"></span>
                                Cargando...
                            </ng-container>
                            <span *ngIf="btn">
                                <i class="fas fa-upload me-2"></i> Subir y procesar archivos
                            </span>
                        </button>
                    </div>
                </div>

                <!-- Resultados del procesamiento -->
                <div class="processing-results mt-4">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                        <h6 class="mb-0">
                            <i class="fas fa-list-alt me-2 text-success"></i>
                            Resoluciones extraídas (<span class="text-primary">{{resolucionesProcesadas.length}}</span>)
                        </h6>
                        <div class="d-flex gap-2">
                            <button type="button" class="btn btn-sm btn-outline-danger" (click)="clearFilesInputProcesar();" [disabled]="!btn">
                                <i class="fas fa-trash me-1"></i>
                                Limpiar todo
                            </button>
                        </div>
                    </div>

                    <!-- Tabla de resultados procesados -->
                    <div class="table-responsive" style="">
                        <table class="table table-sm table-striped">
                            <thead class="table-dark sticky-top">
                                <tr>
                                    <th class="text-center align-middle" style="width: 40px;">
                                        N°
                                    </th>
                                    <th class="text-center align-middle" style="width: 150px;"><p class="lh-sm m-0">Nombre de Resolución</p></th>
                                    <th class="text-center align-middle" style="width: 120px !important;">Fecha</th>
                                    <th class="text-center align-middle">Contenido Extraído</th>
                                    <th class="text-center align-middle" style="width: 90px;">Estado</th>
                                    <th class="text-center align-middle" style="width: 60px;">Acción</th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngIf="resolucionesProcesadas.length === 0">
                                    <tr>
                                        <td colspan="6" class="text-center py-4 text-muted">
                                            No hay resoluciones procesadas
                                        </td>
                                    </tr>
                                </ng-container>
                                <ng-container *ngIf="resolucionesProcesadas.length > 0">
                                    <tr *ngFor="let data of resolucionesProcesadas; let i = index">
                                        <td class="text-center align-middle">{{i + 1}}</td>
                                        <td class="align-middle">
                                            <input type="text" class="form form-control form-control-sm fw-medium" [(ngModel)]="data.Name" name="res-name-{{i}}" [disabled]="!btn"/>
                                            <p class="lh-sm text-muted mb-0" style="font-size: 0.7em;">Archivo: {{data.FileName}}</p>
                                        </td>
                                        <td class="text-center align-middle">
                                            <input type="date" class="form form-control form-control-sm fw-medium" style="width: 120px;" [(ngModel)]="data.Date" name="res-date-{{i}}" [disabled]="!btn"/>
                                        </td>
                                        <td class="align-middle">
                                            <textarea rows="5" class="form form-control form-control-sm lh-sm" [(ngModel)]="data.Content" name="res-content-{{i}}" [disabled]="!btn"></textarea>
                                        </td>
                                        <td class="text-center align-middle">

                                            <span class="badge bg-secondary" *ngIf="data.LoadEstate==0">
                                                <i class="fas fa-clock me-1"></i>Pendiente
                                            </span>
                                            <span class="badge bg-warning" *ngIf="data.LoadEstate==1">
                                                <i class="fas fa-clone me-1"></i>Duplicado
                                            </span>
                                            <span class="badge bg-primary" *ngIf="data.LoadEstate==2">
                                                <i class="fas fa-spinner fa-spin me-1"></i>Guardando
                                            </span>
                                            <span class="badge bg-danger" *ngIf="data.LoadEstate==3">
                                                <i class="fas fa-database me-1"></i>Error en los registros
                                            </span>
                                            <span class="badge bg-danger" *ngIf="data.LoadEstate==4">
                                                <i class="fas fa-cloud-upload-alt me-1"></i>Error en OBS
                                            </span>
                                            <span class="badge bg-success" *ngIf="data.LoadEstate==5">
                                                <i class="fas fa-check-circle me-1"></i>Guardado
                                            </span>

                                        </td>
                                        <td class="text-center align-middle">
                                            <button class="btn btn-sm btn-outline-danger" title="Eliminar" [disabled]="!btn" (click)="clearFileInputProcesar(i)">
                                                <i class="fas fa-trash"></i>
                                            </button>
                                        </td>
                                    </tr>
                                </ng-container>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- Estadísticas del procesamiento -->
                <div class="row mt-3" *ngIf="resolucionesProcesadas.length > 0">
                    <div class="col-md-4">
                        <div class="card bg-primary text-white h-100">
                            <div class="card-body text-center">
                                <i class="fas fa-file-upload fa-2x mb-2"></i>
                                <h4 class="mb-0">{{resolucionesCargadas.length}}</h4>
                                <small>Archivos cargados</small>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="card bg-success text-white h-100">
                            <div class="card-body text-center">
                                <i class="fas fa-check-circle fa-2x mb-2"></i>
                                <h4 class="mb-0">{{getProcesadosExitosos()}}</h4>
                                <small>Procesados exitosamente</small>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="card bg-warning text-white h-100">
                            <div class="card-body text-center">
                                <i class="fas fa-exclamation-triangle fa-2x mb-2"></i>
                                <h4 class="mb-0">{{getProcesadosConError()}}</h4>
                                <small>Con errores</small>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            
            <!-- Footer del Modal -->
            <div class="modal-footer bg-light">
                <div class="d-flex w-100 justify-content-between align-items-center">
                    <div class="text-muted small">
                        <i class="fas fa-info-circle me-1"></i>
                        Se guardarán <strong>{{getProcesadosExitosos()}}</strong> resoluciones válidas en el sistema
                    </div>
                    <div class="d-flex gap-2">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                            <i class="fas fa-times me-1"></i>
                            Cancelar
                        </button>
                        <button type="submit" class="btn btn-primary" [disabled]="!btn || getProcesadosExitosos() === 0">
                            <i class="fas fa-save me-1"></i>
                            Guardar resoluciones ({{getProcesadosExitosos()}})
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>

